import * as React from 'react';
import styled from 'styled-components';
import { Button } from '../../components/button/Button';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SOnlineButton = styled(Button)(
  ({ theme, disabled, margin }) => `
    font-family: 'Poppins';
    width: 271px;
    max-width: 98%;
    height: 40px;
    font-weight: 500;
    border-radius: 35.5px;
    box-shadow: 5.7px 5.7px 13px 0 rgba(0, 0, 0, 0.16);
    margin: ${margin || '30px auto'};
    
    ${
      disabled
        ? `
        box-shadow: none;
        background-color: ${theme.colors.disabledBG};
        cursor: no-drop;
        & span {
          font-family: 'Poppins';
          color: ${theme.colors.disabledText};
        }
      `
        : `
        background-color: ${theme.colors.primaryBright};
        @media only screen and (min-width: 800px) {
            &:hover {
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), ${theme.colors.primaryBright};
              &:before {
                opacity: 0;
              }
            }
          }
      `
    };
    @media only screen and ${theme.device.max.laptopS} {
      width: 271px;
      height: 40px;
      border-radius: 31.1px;
      box-shadow: 4.8px 6.4px 13px 0 rgba(0, 0, 0, 0.16);
    }
    @media only screen and ${theme.device.max.mobileM} {
      width: 100%
    }
      `
);

const SOnlineButtonText = styled.span(
  ({ theme }) => `
    font-family: 'Poppins';
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: center; 
    display: flex;
    align-items: center;
    color: ${theme.colors.white};
  
    @media only screen and ${theme.device.max.laptopS} {
      font-size: ${theme.font.size.medium};
    }
  
    @media only screen and ${theme.device.max.mobileM} {
      font-size: ${theme.font.size.small};
    }
  `
);

export interface IOnlineButtonProps {
  submit: () => void;
  dataAt: string;
  buttonText: string;
  disabled?: boolean;
  margin?: string;
}

export default ({ submit, buttonText, disabled, dataAt, margin }: IOnlineButtonProps) => {
  const handleSubmit = () => {
    submit();
  };
  return (
    <SOnlineButton margin={margin} disabled={disabled} dataAt={dataAt} onClick={handleSubmit}>
      <SOnlineButtonText>{buttonText}</SOnlineButtonText>
    </SOnlineButton>
  );
};
